import React, { useContext } from 'react';
import "../../../../ui-styles/list/contactInfoList.css";
import "../../../../ui-styles/list/CardsList.css";
import { Link } from 'react-router-dom';
import { LangCtx } from "../../../../lib/context";

const BookingStatus = (props) => {
    const { l } = useContext(LangCtx);
    const {doctorData, formData,active} = props;

    return (
        <div className="baColBlock alignCenter">
            <span className="prgrsTxtL">{l.bkng_status}</span>
            { active !=="INI" && <>
            <div className="contactAvtr">
                    <img src="/images/icons/check.png" alt="avatar" className='invertWhite' />
                    {/* <div className="roundimg">{doctorData.firstName.charAt(0)}</div> */}
            </div>
            <span className="contactTxtL mrgTop16">{l.thanks_booking}</span>
            <p className="pTxt txtCenter">{l.apptmnt_sent_request}</p>
            <div className="contactList ">
                <div className="contactDtls alignCenter">
                    <span className="contactTxtL">{l.dr} {doctorData.firstName} {doctorData.lastName ? doctorData.lastName : '' }</span>
                    <span className="contactTxtS">{l.apptmnt_on} {new Date(formData.startTime).toLocaleString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
                    <span className="contactTxtS">{l.reas_for_call}: {l[formData.reason]}</span>
                    {/* <span className="contactTxtS">{l.apptmnt_day} Wednesday</span> */}
                    <span className="contactTxtS">{l.apptmnt_time} {new Date(formData.startTime).toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })} - {new Date(formData.endTime).toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</span>
                    <div className="pushLinkBox">
                        <Link to="/appointments" alt="Upcoming Appointments" className="pushLink">
                            {l.goto_up_meet}
                        </Link>
                    </div>
                </div>
            </div>
            </> }
            {/***** Payment Pending Status *****/}
            {active ==="INI"  && <>
                <div className="bookingStatusCircle">
                    <img src="/images/icons/pending-payment.png" alt="avatar" />
                </div>
                <span className="contactTxtL mrgTop16">{l.pending}</span>
                <p className="pTxt txtCenter">{l.payment_initiated}<br/>
                    {l.payment_pend_txt}.</p>
                <div className="contactList ">
                    <div className="contactDtls alignCenter">
                        <div className="pushLinkBox">
                            <Link to="/appointments" alt="Upcoming Appointments" className="pushLink">
                                {l.goto_up_meet}
                            </Link>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    )
}

export default BookingStatus;